var map = {
	"./dealtNoTrumps_1.png": 1113,
	"./dealtOnly789_1.png": 1114,
	"./dealtOnlyQueensJacks_1.png": 1115,
	"./loseLarge0_1.png": 1116,
	"./loseLarge30_1.png": 1117,
	"./loseLarge60_1.png": 1118,
	"./loseTableAllTricks_1.png": 1119,
	"./loseZoleTwoNines_1.png": 1120,
	"./take0Points_1.png": 1121,
	"./take3Aces_1.png": 1122,
	"./takeTwoAces_1.png": 1123,
	"./takeTwoNines_1.png": 1124,
	"./winLarge120_1.png": 1125,
	"./winLarge61_1.png": 1126,
	"./winLarge91_1.png": 1127,
	"./winSmall120_1.png": 1128,
	"./winSmall60_1.png": 1129,
	"./winSmall90_1.png": 1130,
	"./winZoleAll_1.png": 1131,
	"./winZoleTwoAces_1.png": 1132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;